var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Navigation_24px_Grey_Expand_more",
    "data-name": "Icons / Navigation 24px / Grey / Expand more",
    transform: "translate(-2339 -454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    width: 24,
    height: 24,
    transform: "translate(2339 454)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2355.6,463.117l-4.6,4.4-4.6-4.4-1.4,1.34,6,5.745,6-5.745Z",
    opacity: 0.541
  }))));
};
export default SvgArrowDown;